export const STAGES = [
  { key: "new", label: "New", cls: "bg-slate-100 text-slate-700 border-slate-200", dot: "bg-slate-400" },
  { key: "contacted", label: "Contacted", cls: "bg-blue-50 text-blue-700 border-blue-200", dot: "bg-blue-500" },
  { key: "qualified", label: "Qualified", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500" },
  { key: "proposal", label: "Proposal", cls: "bg-violet-50 text-violet-700 border-violet-200", dot: "bg-violet-500" },
  { key: "negotiation", label: "Negotiation", cls: "bg-amber-50 text-amber-700 border-amber-200", dot: "bg-amber-500" },
  { key: "won", label: "Won", cls: "bg-emerald-600 text-white border-emerald-700", dot: "bg-emerald-700" },
  { key: "lost", label: "Lost", cls: "bg-rose-50 text-rose-700 border-rose-200", dot: "bg-rose-500" },
];
export const stageOf = (k) => STAGES.find((s) => s.key === k) || STAGES[0];

export const SOURCES = ["Website", "Referral", "Google Ads", "Facebook", "LinkedIn", "Cold Call", "Trade Show", "Walk-in", "Other"];
export const INTERESTS = ["Retailer", "Wholesaler", "Dealership", "Distributorship", "Service Provider"];
export const FU_STATUSES = ["Pending", "Completed", "Interested", "Not Interested", "Call Back", "No Response"];
export const INDIAN_STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat", "Haryana",
  "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya",
  "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
  "Uttar Pradesh", "Uttarakhand", "West Bengal", "Andaman and Nicobar Islands", "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry",
];
export const PRIORITIES = ["high", "medium", "low"];
export const PRIORITY_CLS = {
  high: "bg-rose-50 text-rose-700 border-rose-200",
  medium: "bg-amber-50 text-amber-700 border-amber-200",
  low: "bg-slate-100 text-slate-600 border-slate-200",
};
export const MODES = ["Call", "Email", "WhatsApp", "In-Person Meeting", "Demo", "Video Call", "SMS"];
export const OUTCOMES = ["Scheduled", "No Answer", "Interested", "Not Interested", "Call Back Later", "Decision Pending", "Closed"];
export const ROLE_CLS = {
  admin: "bg-violet-100 text-violet-800 border-violet-200",
  sales: "bg-emerald-100 text-emerald-800 border-emerald-200",
  hr: "bg-blue-100 text-blue-800 border-blue-200",
  accounts: "bg-amber-100 text-amber-800 border-amber-200",
};
export const PAY_CLS = {
  paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  partial: "bg-blue-50 text-blue-700 border-blue-200",
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  overdue: "bg-rose-50 text-rose-700 border-rose-200",
};
